var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7716 9.33309V3.43309C25.7716 2.59976 25.1059 1.93309 24.2738 1.93309C23.4417 1.93309 22.776 2.59976 22.776 3.43309V6.59976L15.9861 0.399756C15.4203 -0.133577 14.5216 -0.133577 13.989 0.399756L0.475765 12.6998C-0.123346 13.2664 -0.15663 14.1998 0.375913 14.8331C0.94174 15.4331 1.87369 15.4664 2.50608 14.9331L14.9876 3.53309L27.469 14.8998C27.7686 15.1664 28.1014 15.2664 28.4676 15.2664C28.867 15.2664 29.2997 15.1331 29.5992 14.7664C30.165 14.1664 30.1317 13.1998 29.4994 12.6331L25.7716 9.33309Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00391 15.8334V30H26.1377V15.8334L14.9876 5.93335L4.00391 15.8334ZM13.9891 26.6667H9.22948V21.8667H13.9891V26.6667ZM13.9891 20.4667H9.22948V15.6334H13.9891V20.4667ZM15.9528 15.6334H20.7124V20.4H15.9528V15.6334ZM15.9528 21.8667H20.7124V26.6334H15.9528V21.8667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.010a8555b21879834e5eeec80061980e.svg";
export { ForwardRef as ReactComponent };